// extracted by mini-css-extract-plugin
module.exports = {"content":"forgot-password_content__ttV77","bodyText":"forgot-password_bodyText__kUKBU","form":"forgot-password_form__hx3o6","submitButton":"forgot-password_submitButton__cBMvI"};